import React from "react";
import ReactDOM from "react-dom";
import "./i18n";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initClarity } from "./helpers/ClarityHelper";
import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import "moment/locale/es";

const originalError = console.error;
const resizeObserverMessage =
  "ResizeObserver loop completed with undelivered notifications";
const resizeObserverLimitMessage = "ResizeObserver loop limit exceeded";

const hideWebpackDevOverlay = () => {
  const overlayIds = [
    "webpack-dev-server-client-overlay",
    "webpack-dev-server-client-overlay-div",
  ];

  overlayIds.forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = "none";
    }
  });
};

const isResizeObserverLoopError = (value: unknown) => {
  if (typeof value === "string") {
    return (
      value.includes(resizeObserverMessage) ||
      value.includes(resizeObserverLimitMessage)
    );
  }

  if (value instanceof Error) {
    return (
      value.message.includes(resizeObserverMessage) ||
      value.message.includes(resizeObserverLimitMessage) ||
      value.toString().includes(resizeObserverMessage)
    );
  }

  if (typeof value === "object" && value !== null) {
    const valueWithMessage = value as { message?: unknown };
    const message =
      typeof valueWithMessage.message === "string"
        ? valueWithMessage.message
        : undefined;
    return Boolean(message?.includes(resizeObserverMessage));
  }

  return false;
};

console.error = (...args) => {
  if (args.some(isResizeObserverLoopError)) {
    hideWebpackDevOverlay();
    return;
  }
  originalError.apply(console, args);
};

const handleResizeObserverOverlayError = (
  event: ErrorEvent | PromiseRejectionEvent,
) => {
  const candidate = "reason" in event ? event.reason : event.error ?? event.message;

  if (isResizeObserverLoopError(candidate)) {
    hideWebpackDevOverlay();
    event.preventDefault();
    event.stopImmediatePropagation();
    return true;
  }

  return false;
};

window.onerror = (message, _source, _lineno, _colno, error) => {
  if (
    isResizeObserverLoopError(message) ||
    isResizeObserverLoopError(error)
  ) {
    hideWebpackDevOverlay();
    return true;
  }
  return false;
};

window.addEventListener(
  "error",
  (event) => {
    handleResizeObserverOverlayError(event);
  },
  true,
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    handleResizeObserverOverlayError(event);
  },
  true,
);

initClarity();

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={esES}>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
